label {
  text-transform: none;
}

.close {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  /* color: var(--primary-100); */
}

.previewCell {
  font-size: 0.5rem !important;
  color: var(--primary-100);
  background-color: var(--color-ffffff);
  border-radius: 30px;
  padding: 5px;
}

.button:hover {
  background: var(--primary-100);
  color: var(--color-ffffff);
}

.iconSave {
  display: inline-flex;
  align-items: center;
}

.titleInput {
  display: flex;
  flex-direction: column;
  color: var(--text);
  font:
    700 1rem Roboto,
    sans-serif;
}

.titleComponent input {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 2px solid var(--primary-40);
  border-radius: 15px;
  color: var(--text);
  font:
    normal normal 300 1rem Roboto,
    sans-serif;
  margin: 10px 0 25px 0;
  width: 100%;
  padding: 1rem;
}

.description {
  display: flex;
  flex-direction: column;
  color: var(--text);
  font:
    700 1rem Roboto,
    sans-serif;
}

.reactSelect :global(.select__control) {
  border: 2px solid var(--primary-40);
}

.selectInput div {
  border-color: var(--primary-40) !important;
}
